import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <footer className="footer">

        <div className="container">
            <div className="row">
            <div className="col-xl-5 connect">
                <h2>
                Let's <br /> Connect
                </h2>
            </div>
            <div className="col-xl-7">
                <div className="row">
                <div className="col-xl-6 bengaluru">
                    <p className="fs-5 mt-2">
                    Bangaluru +91 874XXXXXXX info@interiormno.org 08 Tulip Terrace,
                    1023 EF , Bangaluru
                    </p>
                </div>
                <div className="col-xl-6">
                    <p className="fs-5 mt-2">
                    Hyderabad +91 78543XXXXXX info2@interiormno.org 101 Canal View,
                    4567 GH Eindhoven, Hyderabad
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        </footer> 
      </>
  );
};

export default Footer;
